import { render } from "./HomePaperCenter.vue?vue&type=template&id=1c4950ba&scoped=true"
import script from "./HomePaperCenter.vue?vue&type=script&lang=js"
export * from "./HomePaperCenter.vue?vue&type=script&lang=js"

import "./HomePaperCenter.vue?vue&type=style&index=0&id=1c4950ba&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4950ba"]])

export default __exports__